import React from "react";
import styles from "./Destinations4.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations4 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <span className={styles.subtitle}>Curated Collections</span>
        <h2 className={styles.title}>
          Destinations <span>to Inspire</span>
        </h2>
        <div className={styles.line}></div>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.track}>
          {scrollItems.map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.imageWrapper}>
                  <img
                    src={imageUrl}
                    alt={dest?.name || "Destination"}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = fallbackImage;
                    }}
                  />

                  <div className={styles.badge}>Explore</div>
                </div>

                <div className={styles.content}>
                  <h3 className={styles.cardTitle}>
                    {dest?.name || "Explore Destination"}
                  </h3>

                  <p className={styles.category}>Luxury Travel</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations4;